// eslint:disable max-func-body-length
import React, { useState } from 'react';
import { withMetroLine } from 'app/components/metro-line/with-metro-line';
import { WithMetroLineWrappedComponentProps } from 'app/components/metro-line/types';
import { isDefinedIncludingZero } from 'app/infrastructure/data/number';
import { FavouriteSectionType } from '../metroline/types';
import { FavouriteFormProps } from '../types';
import { FavouriteContainer } from './favourite-container';
import { FavouriteDetails } from './favourite-details';
import { FavouriteLanguage } from './favourite-language';
import { FavouriteScheduledReport } from './favourite-schedule';
import { FavouriteSharedWith } from 'app/area/favourite-administration/form/components/favourite-shared-with';
import { FavouriteRecipients } from 'app/area/favourite-administration/form/components/favourite-recipients';
import { FavouriteDashboards } from 'app/area/favourite-administration/form/components/favourite-dashboards';
import { FavouriteCompanyReports } from 'app/area/favourite-administration/form/components/favourite-company-reports';

const FavouriteFormRendererContainer: React.FC<FavouriteFormProps
  & WithMetroLineWrappedComponentProps<FavouriteSectionType>> = ({
    formState, mainLanguage, saveFavourite, deleteFavourite, updateItem, changeLanguage,
    copyLanguageToAll, changeLongDescription, copyLongDescriptionToAll, options, shouldPrompt, 
    loadOptions, updateValidation, deleteSchedule, scheduleDeleting, clearParent,
    resetValidation, displayError, locale, translation, section, getRef, shouldRenderSection
  }) => {

    const { favouriteItem, originalFavouriteItem, languageOptions, validation } = formState;
    const [showTranslations, switchTranslationsToggle] = useState(isDefinedIncludingZero(favouriteItem?.id));
    const [hideRemoveSchedule, setHideRemoveSchedule] = useState(false);
    const panelProps = {
      favouriteItem,
      originalFavouriteItem,
      options,
      locale,
      validation,
      translation,
      section,
      mainLanguage,
      getRef,
      shouldRenderSection,
      loadOptions,
      updateItem,
      updateValidation,
      resetValidation,
      displayError,
      scheduleDeleting,
      deleteSchedule,
      clearParent,
      hideRemoveSchedule, 
      setHideRemoveSchedule
    };

    const renderLanguageOnTop = !isDefinedIncludingZero(favouriteItem?.id);
    const languageSection = <FavouriteLanguage
      language={favouriteItem?.language}
      longDescription={favouriteItem?.longDescription}
      mainLanguage={mainLanguage}
      languageOptions={languageOptions}
      changeLanguage={changeLanguage}
      copyLanguageToAll={copyLanguageToAll}
      changeLongDescription={changeLongDescription}
      copyLongDescriptionToAll={copyLongDescriptionToAll}
      showTranslations={showTranslations}
      switchTranslationsToggle={switchTranslationsToggle}
      validation={validation}
      translation={translation}
      section={section}
      getRef={getRef}
      shouldRenderSection={shouldRenderSection} />;

    return <FavouriteContainer
      formState={formState}
      mainLanguage={mainLanguage}
      shouldPrompt={shouldPrompt}
      switchTranslationsToggle={switchTranslationsToggle}
      saveFavourite={saveFavourite}
      deleteFavourite={deleteFavourite}
      updateValidation={updateValidation}
      displayError={displayError}
      validation={validation}
      translation={translation}
      locale={locale}>
      {renderLanguageOnTop && languageSection}
      <FavouriteDetails {...panelProps} />
      <FavouriteSharedWith {...panelProps} />
      <FavouriteDashboards {...panelProps} />
      <FavouriteCompanyReports {...panelProps} />
      <FavouriteScheduledReport {...panelProps} />
      <FavouriteRecipients {...panelProps} />
      {!renderLanguageOnTop && languageSection}
    </FavouriteContainer>;
  };

export const FavouriteFormRenderer = withMetroLine<FavouriteFormProps,
  FavouriteSectionType>()(FavouriteFormRendererContainer);
